// Produktseite: Packungswahl, Preis pro Samen, Galerie, In den Warenkorb, mobile Kaufleiste.
// Der Warenkorb meldet sich ueber das Shopify-Standard-Event CartLinesUpdateEvent, genau wie Horizons
// eigenes Produktformular. Darauf hoeren Drawer, Zaehler im Header und Positionsliste.
import { CartLinesUpdateEvent } from '@shopify/events'

// Preise und Preis pro Samen rechnet und formatiert Liquid (gleich wie die Karte), hier wird nur umgeschaltet.

class HdscBuy extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-buy-form]')
    this.idInput = this.querySelector('[data-variant-id]')
    this.cta = this.querySelector('[data-cta]')
    this.bbCta = this.querySelector('[data-bb-cta]')
    this.buybar = this.querySelector('[data-buybar]')

    this.form.addEventListener('change', (e) => { if (e.target.name === 'hdsc-pack') this.select(e.target) })
    this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add() })
    this.bbCta.addEventListener('click', () => this.add())

    const checked = this.form.querySelector('input[name="hdsc-pack"]:checked')
    if (checked) this.select(checked)

    // Kaufleiste: Positionspruefung statt IntersectionObserver, schnelles Wischen springt sonst darueber
    const sync = () => {
      const on = this.cta.getBoundingClientRect().bottom < 0
      this.buybar.classList.toggle('is-on', on)
      this.buybar.inert = !on
    }
    const wrapper = document.querySelector('.page-wrapper')
    addEventListener('scroll', sync, { passive: true })
    wrapper?.addEventListener('scroll', sync, { passive: true })
    sync()
  }

  select(input) {
    const d = input.dataset
    const available = d.available === 'true'
    this.idInput.value = input.value
    this.querySelector('[data-amount]').textContent = d.price
    const compare = this.querySelector('[data-compare]')
    compare.textContent = d.compare
    compare.hidden = !d.compare
    this.querySelector('[data-per-seed]').textContent = d.perSeed
    const stock = this.querySelector('[data-stock]')
    // Bald verfuegbar und Vorbestellung kommen vom Server (data-soon, data-pre). Ein Packungswechsel darf den Button nicht freischalten.
    const soon = this.dataset.soon === 'true'
    const pre = soon || (available && this.dataset.pre === 'true')
    stock.className = 'pdp__stock ' + (pre ? 'is-pre' : available ? 'is-in' : 'is-out')
    stock.textContent = soon ? stock.dataset.soonText : available ? stock.dataset.in : 'Ausverkauft'
    const label = soon ? 'Bald verfügbar' : available ? (this.dataset.pre === 'true' ? 'Vorbestellen' : 'In den Warenkorb') : 'Ausverkauft'
    for (const b of [this.cta, this.bbCta]) { b.textContent = label; b.disabled = soon || !available }
    this.querySelector('[data-bb-price]').textContent = d.price
    this.querySelector('[data-bb-pack]').textContent = d.title
  }

  toast(msg) {
    const t = this.querySelector('[data-toast]')
    t.textContent = msg
    t.classList.add('is-on')
    clearTimeout(this.toastTimer)
    this.toastTimer = setTimeout(() => t.classList.remove('is-on'), 2600)
  }

  async add() {
    if (this.cta.disabled || this.busy) return
    this.busy = true
    const error = this.querySelector('[data-error]')
    error.hidden = true
    const id = this.idInput.value
    const pack = this.querySelector('[data-bb-pack]').textContent.trim()
    const sections = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean)
    const deferred = CartLinesUpdateEvent.createPromise()
    this.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product',
      lines: [{ merchandiseId: id, quantity: 1 }],
      promise: deferred.promise,
    }))
    try {
      const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +id, quantity: 1 }], sections: sections.join(',') }),
      })
      const data = await res.json()
      const cart = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.json`).then((r) => r.json())
      const failed = !res.ok || data.status
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'hdsc-buy', sourceId: this.dataset.productId, itemCount: 1, productId: this.dataset.productId, sections: data.sections, didError: !!failed },
      })
      if (failed) {
        error.textContent = data.description || data.message || 'Das hat nicht geklappt. Bitte versuch es noch einmal.'
        error.hidden = false
      } else {
        this.toast(`${this.dataset.name}${pack ? ` (${pack})` : ''} liegt im Warenkorb`)
      }
    } catch (e) {
      deferred.reject(e)
      error.textContent = 'Keine Verbindung. Bitte versuch es noch einmal.'
      error.hidden = false
    } finally {
      this.busy = false
    }
  }
}
if (!customElements.get('hdsc-buy')) customElements.define('hdsc-buy', HdscBuy)

// Galerie: Klick auf ein Vorschaubild zeigt es gross. Auf dem Handy ist die Flaeche wischbar (CSS scroll-snap), Vorschaubilder scrollen dorthin.
const swipeMq = window.matchMedia('(max-width: 900px)')
document.querySelectorAll('[data-gallery]').forEach((g) => {
  const main = g.querySelector('.pdp__main')
  const thumbs = g.querySelectorAll('[data-thumb]')
  const imgs = g.querySelectorAll('.pdp__main img')
  // Handy: alle Bilder sichtbar (wischbar). Desktop: nur das gewaehlte Bild.
  const sync = () => {
    const cur = [...thumbs].find((b) => b.getAttribute('aria-pressed') === 'true')?.dataset.thumb ?? '0'
    imgs.forEach((img) => (img.hidden = !swipeMq.matches && img.dataset.index !== cur))
    if (swipeMq.matches && main) main.scrollLeft = Number(cur) * main.clientWidth
  }
  const mark = (i) => thumbs.forEach((b) => b.setAttribute('aria-pressed', b.dataset.thumb === String(i)))
  g.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]')
    if (!t) return
    const i = t.dataset.thumb
    if (swipeMq.matches && main) {
      main.scrollTo({ left: Number(i) * main.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
      mark(i)
      return
    }
    g.querySelectorAll('.pdp__main img').forEach((img) => (img.hidden = img.dataset.index !== i))
    mark(i)
  })
  if (main && thumbs.length) {
    sync()
    swipeMq.addEventListener('change', sync)
    main.addEventListener('scroll', () => {
      if (swipeMq.matches) mark(Math.round(main.scrollLeft / (main.clientWidth || 1)))
    }, { passive: true })
  }
})
